module.exports = __webpack_public_path__ + "static/media/4279.51662200.jpg";